[
  {
    "code": "BN-BE",
    "name": "Belait"
  },
  {
    "code": "BN-BM",
    "name": "Brunei-Muara"
  },
  {
    "code": "BN-TE",
    "name": "Temburong"
  },
  {
    "code": "BN-TU",
    "name": "Tutong"
  }
]